<template>
  <base-promo-badge
    :text="i18n('tariff', tariffGroup)"
  />
</template>

<script lang="ts" setup>
import { useI18N } from '@/shared/legacy/lib/use-i18n';
import BasePromoBadge from '@/shared/ui/base-promo-badge/base-promo-badge.vue';

type Props = {
  tariffGroup: any;
};

defineProps<Props>();

const i18n = useI18N();
</script>

<i18n lang="json">
{
  "tariff": {
    "ru_RU": "Тариф {name}",
    "en_US": "{name}"
  }
}
</i18n>
